(() => {
  const closeAllShippingPopovers = (except) => {
    document.querySelectorAll('[data-article-banner-shipping-popover]').forEach((popover) => {
      if (popover !== except) popover.hidden = true;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-article-banner-info]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      const wrap = button.closest('.article-product-banner__flag-wrap');
      const popover = wrap && wrap.querySelector('[data-article-banner-shipping-popover]');
      if (!popover) return;
      const willOpen = popover.hidden;
      closeAllShippingPopovers(popover);
      popover.hidden = !willOpen;
      button.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    if (!event.target.closest('.article-product-banner__flag-wrap')) {
      closeAllShippingPopovers();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllShippingPopovers();
  });
})();